import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useTheme } from "styled-components";
import Axios from "axios";

import { getStartSeconds, getEndSeconds } from "../../../../../common/parameters";
import theme from "../../../../style/theme";

import Wrapper from "../../Wrapper";

import NotEdited from "../Common/NotEdited";

import { StyledEmbed, Preview, PreziPreview } from "./styles";
import messages from "./messages";
import { ICommonTaskProps, IEmbedData, IProvider } from "../../../../../common/types";

const Embed = (props: ICommonTaskProps) => {
    if (props.setReset) {
        props.setReset(() => {});
    }
    if (props.saveState) {
        props.saveState(() => ({}));
    }
    if (props.restoreState) {
        props.restoreState(() => {});
    }
    if (props.showSolution) {
        props.showSolution(() => {});
    }
    const { c } = useTheme() as typeof theme;
    const { preview, task, join, isExperienceCenter } = props;
    const data = task.data as IEmbedData;
    const { provider = IProvider.YouTube } = data;
    const [vimeoPreview, setVimeoPreview] = useState("");
    useEffect(() => {
        if (provider === IProvider.Vimeo && data.href && preview) {
            Axios.get(`//vimeo.com/api/v2/video/${data.href}.json`).then((result) => {
                setVimeoPreview(result.data[0].thumbnail_medium);
            })
        }
    }, []);
    if (join)
        return (
            <div>
                <FormattedMessage {...messages.lookUp} />
            </div>
        );
    if (!data || !data.href)
        return (
            <div>
                <Wrapper>
                    <NotEdited />
                </Wrapper>
            </div>
        );

    return (
        <div>
            <Wrapper isExperienceCenter={isExperienceCenter}>
                <StyledEmbed>
                    {!preview ? (
                        <iframe
                            title={"video-iframe"}
                            width="1280"
                            height="720"
                            src={
                                provider === IProvider.Vimeo ? (
                                    `https://player.vimeo.com/video/${data.href}?color=${c.boost.slice(1)}#t=${data.startHour || 0}h${data.startMinute || 0}m${data.startSecond || 0}s`
                                )
                                : provider === IProvider.YouTube ? (
                                    "https://www.youtube-nocookie.com/embed/" +
                                    data.href +
                                    "?start=" +
                                    getStartSeconds(data) +
                                    "&end=" +
                                    getEndSeconds(data)
                                )
                                : (
                                    `https://prezi.com/p/${data.href}/embed`
                                )
                            }
                            frameBorder="0"
                            allow="accelerometer; autoplay; encrypted-media; picture-in-picture"
                            allowFullScreen
                        />
                    ) : (
                        <Preview
                            style={{
                                ...(provider !== IProvider.Prezi && {
                                    backgroundImage: 
                                        `url("${provider === IProvider.Vimeo
                                            ? vimeoPreview
                                            : `//i3.ytimg.com/vi/${data.href}/hqdefault.jpg`
                                        }")`
                                })
                            }}
                        >
                            {provider === IProvider.Prezi && (
                                <PreziPreview />
                            )}
                        </Preview>
                    )}
                </StyledEmbed>
            </Wrapper>
        </div>
    );
}

export default Embed;
